/** @jsx jsx */
import React from 'react';
import { DeprecatedButton } from '@balance-web/button-deprecated';
import { jsx } from '@balance-web/core';
import { Heading } from '@balance-web/heading';
import { Flex } from '@balance-web/flex';
import { Stack } from '@balance-web/stack';
import { Text } from '@balance-web/text';
import { HeroNotFound } from '@balance-web/illustration';

type NotFoundPageProps = {
  onGotoHomepageClick: () => void;
};

export function NotFoundPage({ onGotoHomepageClick }: NotFoundPageProps) {
  return (
    <Stack flexGrow={1}>
      <Flex
        width="100%"
        direction="column"
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
      >
        <Stack align="center" gap="xxlarge">
          <HeroNotFound />
          <Stack align="center" gap="large">
            <Heading level="4">Page not found</Heading>
            <Text
              color="muted"
              size="small"
              leading="loose"
              weight="medium"
              align="center"
            >
              We can't find the page you're looking for. It might be an old link{' '}
              <br />
              or may be it moved.
            </Text>
          </Stack>
          <DeprecatedButton
            id="404-go-home"
            label="Go to Homepage"
            onClick={onGotoHomepageClick}
          />
        </Stack>
      </Flex>
    </Stack>
  );
}
